import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-sort",
  templateUrl: "./med-icon-sort.component.html",
})
export class MedIconSortComponent extends SvgMixinComponent {}
